module.exports = __webpack_public_path__ + "images/emoji/m.983e416e3322d497e032.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/m.png
// module id = kgu2
// module chunks = 24